import { CrudTable, StatusBadge, Rating } from "@/components/shared";

const TOUCHPOINTS = ["Telecaller", "Reception", "Doctor", "Pre-Op", "Procedure", "Post-Op", "Overall"];
const YesNo = ({ v }) => <span className={v ? "text-[#f87171]" : "text-slate-500"}>{v ? "Yes" : "No"}</span>;

export default function Feedback() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "touchpoint", label: "Touchpoint", render: (r) => <StatusBadge value={r.touchpoint} /> },
    { key: "feedback_text", label: "Feedback", render: (r) => <span className="max-w-xs truncate block text-slate-300">{r.feedback_text || "—"}</span> },
    { key: "rating", label: "Rating", render: (r) => <Rating value={r.rating} /> },
    { key: "sentiment", label: "Sentiment", render: (r) => r.sentiment ? <StatusBadge value={r.sentiment} /> : "—" },
    { key: "action_needed", label: "Action", render: (r) => <YesNo v={r.action_needed} /> },
    { key: "shared_with", label: "Shared With" },
  ];
  const fields = [
    { key: "patient_id", label: "Patient (linked)", type: "patient", full: true },
    { key: "patient_name", label: "Patient Name (or type manually)", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "touchpoint", label: "Touchpoint", type: "select", options: TOUCHPOINTS },
    { key: "rating", label: "Rating (1-5)", type: "number", min: 1, max: 5, step: 1 },
    { key: "shared_with", label: "Shared With", type: "select", options: ["Reception", "Doctor", "Branch Head"] },
    { key: "feedback_text", label: "Feedback (AI auto-tags sentiment on save)", type: "textarea", full: true },
  ];
  return (
    <CrudTable testid="feedback" endpoint="feedback" dateField="date"
      title="Feedback Collection"
      subtitle="AI auto-tags sentiment. Negative feedback (≤2 or negative) auto-escalates into the Concern Log — no re-entry."
      columns={columns} fields={fields}
      defaults={{ touchpoint: "Overall", rating: 5 }}
    />
  );
}
